@if(editPopover) {
    <app-save-view [savedViewToEdit]="inputSavedView">
    </app-save-view>
} @else {
    <div class="c-popover-options">
        <button class="c-popover-options__btn" (click)="gotoView()">{{lang.GetValue('SavedViews.GoToView')}}</button>
        <button class="c-popover-options__btn" (click)="$event.stopPropagation(); editPopover = true;">
            {{lang.GetValue('SavedViews.Edit')}}
        </button>
        <button class="c-popover-options__btn" (click)="removeView()">{{lang.GetValue('SavedViews.Delete')}}</button>
    </div>
}